define('Components/AdvantageWidget/js/models/AdvantageWidgetInstanceModel',['underscore',
        'WidgetInstanceModel',
        'Components/AdvantageWidget/js/models/AdvantageWidgetModel'
    ],
    function (_,
              WidgetInstanceModel,
              AdvantageWidgetModel) {

    //
    // Instance de Widget
    //

    return WidgetInstanceModel.extend({
        name: 'AdvantageWidgetModel',
        init: function () {
            var model = this,
                advantageList = new AdvantageWidgetModel({id_widget_instance: model.get('id_widget_instance')});

            function onSync() {
                model.set('advantageList',advantageList);
                model.trigger('advantageList');
            }

            advantageList.once('sync', onSync);
            advantageList.fetch();
        },
        getTitle:function () {
            return this.p('title');
        },
        getIcon:function () {
            return this.p('icon');
        },
        getAllDiscount: function () {
            var model = this,
                advantageList = model.get('advantageList'),
                discounts = advantageList ? advantageList.getDiscounts() : [];
            return _(discounts);
        },
        getModel:function()
        {
            return this;
        },
    })
});
